module.exports = __webpack_public_path__ + "media/img/icons/orsag-59fbb252e914f0732b9efdb1f035256a.png";